import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../Components/ComponentButton';
import T from '../../Locale';
const ContinueButton = ({ id, onClick = null }) => (_jsx("div", Object.assign({ className: 'save-class text-center' }, { children: _jsxs("div", Object.assign({ className: 'columns small-12' }, { children: [_jsx("br", {}), _jsx(Button, { id: `save-${id}`, title: T('partner.signup.save'), onClick: onClick })] })) })));
ContinueButton.propTypes = {
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func
};
export default ContinueButton;
